import * as React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Stack,
  Link,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import { checkPrivileges } from "../utils/PrivilegesHelper";
import { PrivilegesContext } from "../PrivilegesContext";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const BuilderTools: React.FC = () => {
  const history = useHistory();
  const userPrivileges = React.useContext(PrivilegesContext);

  const settingsMenus = [
    {
      title: "Encounter Templates",
      description:
        "Create and manage the templates your team uses within encounters. Use this section to define the templates for encounter notes and patient instructions.",
      url: "templates-list",
      enabled: true,
      showDisabled: true,
    },
    {
      title: "Living Facility Builder",
      description:
        "Set up and maintain the list of living facilities your organization works with. Add facility details, update contact information, and keep everything organized for smooth care coordination.",
      url: "facilities",
      enabled: checkPrivileges(
        userPrivileges,
        "Access Living Facility Builder"
      ),
      showDisabled: true,
    },
    {
      title: "Questionnaire Builder",
      description:
        "Design and edit the questionnaires your team uses for patients or staff. Customize questions, response types, and layout to ensure you collect the right information in a clear and structured way.",
      url: "questionnaires-list",
      enabled: checkPrivileges(userPrivileges, "Build Questionnaire"),
      showDisabled: true,
    },
  ];

  const handleRouteNavigation = (route) => {
    history.push(`/${route}`);
  };

  return (
    <div className="settings-index-container">
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        className="container"
      >
        <Grid item xs={12} md={12}>
          <div className="userAdminInformation">
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="stretch"
              className="adminHeader"
            >
              <Grid item xs={12} md={6}>
                <Stack direction="row" columnGap="12px">
                  <Link
                    style={{
                      textDecoration: "none",
                      display: "flex",
                      alignItems: "center",
                    }}
                    href={`/settings`}
                  >
                    <ArrowBackIosNewIcon
                      style={{
                        borderRadius: "3px",
                        padding: "8px",
                        color: "black",
                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        fontSize: "14px",
                      }}
                    />
                  </Link>
                  <h3>Settings - Builder Tools</h3>
                </Stack>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="divider"></div>
        </Grid>

        <div className="settings-inner-container" style={{ width: "100%" }}>
          <Grid container spacing={3}>
            {settingsMenus.map((settingsMenu, index) => {
              if (settingsMenu.enabled) {
                return (
                  <Grid item xs={12} sm={6} md={4} key={index + 1}>
                    <Card
                      className="item-card"
                      onClick={() => handleRouteNavigation(settingsMenu.url)}
                    >
                      <CardContent className="card-content">
                        <Typography className="card-title">
                          {settingsMenu.title}
                        </Typography>
                        <Typography className="card-description">
                          {settingsMenu.description}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              }

              if (!settingsMenu.enabled && settingsMenu.showDisabled) {
                return (
                  <Grid item xs={12} sm={6} md={4} key={index + 1}>
                    <Card className="item-card-disabled">
                      <CardContent className="card-content">
                        <Typography className="card-title-disabled">
                          {settingsMenu.title}
                        </Typography>
                        <Typography className="card-description-disabled">
                          {settingsMenu.description}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              }

              return null;
            })}
          </Grid>
        </div>
      </Grid>
    </div>
  );
};

export default BuilderTools;
